/* import __COLOCATED_TEMPLATE__ from './health-filter.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';

export type HealthFilterValue = 'all' | 'healthy' | 'degraded' | 'unhealthy';

interface Signature {
  Args: {
    selectedHealth: HealthFilterValue;
    onHealthChange: (health: HealthFilterValue) => void;
  };
  Element: HTMLDivElement;
}

export default class WorkflowConnectorHealthFilter extends Component<Signature> {
  @service declare intl: IntlService;

  get dropdownLabel(): string {
    switch (this.args.selectedHealth) {
      case 'healthy':
        return this.intl.t('workflow-connector.list.health.status.healthy');
      case 'degraded':
        return this.intl.t('workflow-connector.list.health.status.degraded');
      case 'unhealthy':
        return this.intl.t('workflow-connector.list.health.status.unhealthy');
      default:
        return this.intl.t('workflow-connector.actions.filters.health.label');
    }
  }

  get filterOptions() {
    return [
      {
        id: 'all' as HealthFilterValue,
        label: this.intl.t('workflow-connector.actions.filters.health.all'),
        testId: 'all',
      },
      {
        id: 'healthy' as HealthFilterValue,
        label: this.intl.t('workflow-connector.list.health.status.healthy'),
        testId: 'healthy',
      },
      {
        id: 'degraded' as HealthFilterValue,
        label: this.intl.t('workflow-connector.list.health.status.degraded'),
        testId: 'degraded',
      },
      {
        id: 'unhealthy' as HealthFilterValue,
        label: this.intl.t('workflow-connector.list.health.status.unhealthy'),
        testId: 'unhealthy',
      },
    ];
  }

  @action
  selectHealth(healthValue: HealthFilterValue) {
    this.args.onHealthChange(healthValue);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::HealthFilter': typeof WorkflowConnectorHealthFilter;
    'workflow-connector/health-filter': typeof WorkflowConnectorHealthFilter;
  }
}
